import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Organization User List Config"})
export default class Config {

	@Input({type: InputType.TEXT, title: "Widget Title"})
	public title: string = "";
	
    @Input({type: InputType.TEXT, title: "through"})
    public dateResource: string = "through";

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/announcements/Config.ts